export default class ConsoleTransport {
    #errorAsWarning;
    constructor({ errorAsWarning = false } = {}) {
        this.#errorAsWarning = errorAsWarning;
    }
    log({ level, namespace, args }) {
        if (namespace) {
            const prefix = level === 'log' ? `[${namespace}]` : `[${namespace}:${level}]`;
            args = [prefix, ...args];
        }
        if (this.#errorAsWarning && level === 'error') {
            level = 'warn';
        }
        console[level](...args);
    }
}
